import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = ({ width = '100%', height = 'auto', style = {} }) => (
  <div style={{ maxWidth: '577px', margin: '0 auto', ...style }}>
    <ContentLoader
      speed={2}
      style={{ width, height }}
      primarycolor="#f3f3f3"
      secondarycolor="#ecebeb"
    >
      <rect x="0" y="40" rx="6" ry="6" width="45%" height="20" />
      <rect x="0" y="70" rx="6" ry="6" width="35%" height="20" />
      <rect x="0" y="100" rx="6" ry="6" width="55%" height="20" />
      <rect x="0" y="130" rx="6" ry="6" width="40%" height="20" />
    </ContentLoader>
  </div>
);

export default Loader;
